import { actions as labelActions } from 'actions/labels';

const regeneration = (state = {}, action) => {
  const { type, payload } = action;

  switch (type) {
    case labelActions.initLabels:
      return payload.regeneration || state;
    default:
      return state;
  }
};

export default regeneration;



// WEBPACK FOOTER //
// ./src/reducers/regeneration.js